// packages/web/src/api/trip-declarations/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { tripDeclarationsList, tripDeclarationsGet } from "../generated/sdk.gen.ts";
import { tripKeys } from "./keys.ts";

export function tripInboxOptions(userId: string) {
  return queryOptions({
    queryKey: tripKeys.inbox(userId),
    queryFn: async () => {
      const { data, error } = await tripDeclarationsList({ query: { inbox: "me" } });
      if (error) throw error;
      if (!data) throw new Error("Trip inbox failed");
      return data.data;
    },
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}

export function tripDetailOptions(id: string) {
  return queryOptions({
    queryKey: tripKeys.detail(id),
    queryFn: async () => {
      const { data, error } = await tripDeclarationsGet({ path: { id } });
      if (error) throw error;
      if (!data) throw new Error("Trip get failed");
      return data;
    },
    staleTime: 30_000,
  });
}
